import React, { useRef } from 'react';

import { FormikHelpers } from 'formik';

import OnboardingSelect from 'components/Selects/OnboardingSelect';
import useStoreTranslation from 'hooks/useStoreTranslation';

import { Error } from './styles';

interface Props {
  id?: string;
  type?: string;
  value?: string;
  placeholder?: string;
  disabled?: boolean;
  error?: string;
  formik?: FormikHelpers<string>;
}

const GenreSelector = ({ value, formik, error, disabled }: Props) => {
  const ref = useRef<HTMLDivElement>(null);
  const { t } = useStoreTranslation();
  const GENRE_TYPES = [
    { id: 'Male', name: t('personalDataForm.genreSelectorMale') },
    { id: 'Female', name: t('personalDataForm.genreSelectorFemale') },
  ];

  const handleChange = (newValue: any) => formik?.setFieldValue('gender', newValue);

  return (
    <div ref={ref}>
      <OnboardingSelect
        disabled={disabled}
        title={t('personalDataForm.genre')}
        options={GENRE_TYPES}
        value={value}
        onChange={handleChange}
      />
      {error && <Error>{error}</Error>}
    </div>
  );
};

export default GenreSelector;
